import { render, staticRenderFns } from "./a-rich-text.vue?vue&type=template&id=34439cb5&"
import script from "./a-rich-text.vue?vue&type=script&lang=js&"
export * from "./a-rich-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports